import { getDentalCorpBackend } from '../commons/backend/dentalCorpBackendProxy';
const dentalCorpBackend = getDentalCorpBackend();

export const fetchSPJBatchJobs =
	(page = 1, size = 10, batch_id = '', status = '', event = '', row = '') =>
	async (dispatch, getState) => {
		try {
			const response = await dentalCorpBackend.fetchSPJBatchJobs(getState(), page, size, batch_id, status, event, row, dispatch);
			return response;
		} catch (error) {
			console.log(error);
		}
	};

export const fetchSPJBatchMetric =
	(batch_id = '') =>
	async (dispatch, getState) => {
		try {
			if (!batch_id) return [];
			const response = await dentalCorpBackend.fetchSPJBatchMetric(getState(), batch_id, dispatch);
			return response;
		} catch (error) {
			console.log(error);
		}
	};

export const fetchSPJActiveBatches =
	(status = '', event = '') =>
	async (dispatch, getState) => {
		try {
			const response = await dentalCorpBackend.fetchSPJActiveBatches(getState(), status, event, dispatch);
			return response;
		} catch (error) {
			console.log(error);
		}
	};

export const clearSPJFailed =
	(batch_id = '') =>
	async (dispatch, getState) => {
		try {
			const body = {
				batch_id,
			};
			const response = await dentalCorpBackend.clearSPJFailed(getState(), body, dispatch);
			return response;
		} catch (error) {
			console.log(error);
		}
	};

export const downloadSPJErrors =
	(action = 'FILE_UPLOAD', batch_id = '', onFailure = null) =>
	async (dispatch, getState) => {
		try {
			await dentalCorpBackend.downloadSPJErrors(getState(), action, batch_id, dispatch);
		} catch (error) {
			onFailure(error);
		}
	};
